import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Container,
  Grid2,
  Typography,
  Button,
  Chip,
  Snackbar,
  Tooltip,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { NoDataPlaceholder } from "../ApplicationDetailsAdditionalDocument/ApplicationDetailsAdditionalDocument";

// Helper function for common Chip styles
const getChipBaseStyles = () => ({
  width: "fit-content",
  fontFamily: "Roboto",
  background: "#E0E0E0",
  color: "#222",
  fontWeight: 400,
  fontStyle: "Regular",
  fontSize: "14px",
  borderRadius: "6px",
  leadingTrim: "NONE",
  lineHeight: "100%",
  letterSpacing: 0,
  height: "32px",
});

const getDeleteIconStyles = () => ({
  color: "#717273",
  background: "white !important",
  borderTopRightRadius: "6px",
  borderBottomRightRadius: "6px",
  boxShadow: "none",
  border: "1px solid #E0E0E0 !important",
  borderLeft: "none !important",
  marginRight: "-8px !important",
  height: "95%",
});

const getChipWithDeleteStyles = () => ({
  ...getChipBaseStyles(),
  paddingRight: "8px",
  textAlign: "center",
  ".MuiChip-label": { paddingRight: "8px" },
  ".MuiChip-deleteIcon": {
    marginRight: "2px",
    marginLeft: "8px",
    background: "white",
  },
});

const getChipWithoutDeleteStyles = () => ({
  ...getChipBaseStyles(),
  ".MuiChip-label": { paddingRight: 0 },
  ".MuiChip-deleteIcon": {
    marginRight: "4px !important",
    marginLeft: "8px",
    background: "none",
  },
});
import AddFlexMetaDataDialog from "./AddFlexMetaDataDialog";
import {
  fetchFlexMetaDataLabels,
  postFlexMetaDataLabels,
} from "../../Services/redux/FlexMetaData/FlexMetaDataActions";
import { patchPortfolioAppApproveRejectDetails } from "../../Services/redux/Application-details/ApplicationDetailsActions";
import { useParams } from "react-router-dom";
import {
  fetchGlobalAdminFlexMetadata,
  setGlobalFlexMetaDataChipList,
  setSubmissionAPIdata,
  setSubmissionFlexMetadataIds,
} from "../../Services/redux/global-admin-users/flex metadata/GlobalAdminFlexActions";
import APIManager from "../../Services/ApiManager/ApiManager";

// SDD87MARKETPLACE468R120:
// CODE87MARKETPLACE468R120: Add Flex Metadata from Master Table to Submission
// Related items (auto-generated):
// End related items

// SDD88MARKETPLACE468R120:
// CODE88MARKETPLACE468R120: Create New Flex Metadata from Submission Details
// Related items (auto-generated):
// End related items

// SDD89MARKETPLACE1029R120:
// CODE89MARKETPLACE1029R120: Remove Flex Metadata from Submission
// Related items (auto-generated):
// End related items
function ApplicationDetailsFlexMetaData({ submissionData }) {
  const dispatch = useDispatch();
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [flexMetaDataList, setFlexMetaDataList] = useState([]);
  const {
    globalFlexMetaDataChipList = [],
    submissionAPIdata = {},
  } = useSelector((state) => state.globalAdminFlexReducers || {});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [newLabelAdded, setNewLabelAdded] = useState(false);
  const [newLabelNotPresentInTheList, setNewLabelNotPresentInTheList] =
    useState("");
  const [snackMsg, setSnackMsg] = useState("");
  const flexMetaDataState = useSelector(
    (state) => state.flexMetaDataReducer.labels
  );

  const { flexMetadata: globalFlexMetadata = [] } = useSelector(
    (state) => state.globalAdminFlexReducers || {}
  );

 const flexNameOptions = [
    ...(Array.isArray(globalFlexMetadata) ? globalFlexMetadata : []).map((item) => item?.name || item?.title || ""),
    ...(Array.isArray(flexMetaDataState) ? flexMetaDataState : []).map((item) => item?.title || item?.name || "")
  ].filter(Boolean);

  const { appId, submissionId } = useParams();

 useEffect(() => {
    if (sessionStorage.getItem("customPortal") === "oem-admin") {
      try {
        dispatch(fetchFlexMetaDataLabels());
      } catch (err) {
        console.log("Error: ", err);
      }
    }
  }, [dispatch]);

  const fetchGlobalFlexChipsList = async (appId, submissionId) => {
    if (sessionStorage.getItem("customPortal") === "global-admin") {
      try {
        const submissionGlobalAPIdata =
          await APIManager.getGlobalAdminFlexSubmissionAPIData(
            appId,
            submissionId
          );

        const flexMetadataIds = submissionGlobalAPIdata.flexMetadata || [];
        const filteredFlexMetaChipList = globalFlexMetadata.filter((item) =>
          flexMetadataIds.includes(item.id)
        );
        dispatch(setSubmissionAPIdata(submissionGlobalAPIdata));

        dispatch(setSubmissionFlexMetadataIds(flexMetadataIds));

        dispatch(setGlobalFlexMetaDataChipList(filteredFlexMetaChipList));
      } catch (err) {
        console.log("Error fetching global flex metadata chip list: ", err);
      }
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("customPortal") === "global-admin") {
      try {
        dispatch(fetchGlobalAdminFlexMetadata());
      } catch (err) {
        console.log("Error: ", err);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      sessionStorage.getItem("customPortal") === "global-admin" &&
      Array.isArray(globalFlexMetadata) &&
      globalFlexMetadata.length > 0
    ) {
      fetchGlobalFlexChipsList(appId, submissionId);
    }
  }, [appId, submissionId, globalFlexMetadata]);

  const handleSave = (name) => {
    const findIndexOfNameAvailableOrNot = flexMetaDataState.findIndex(
      (label) => label.title === name
    );
    // Your save logic here
    if (flexMetaDataList.includes(name)) {
      setSnackMsg("Flex metadata already exists.");
      setOpenSnackbar(true);
      return;
    } else if (!/^[a-zA-Z0-9_-]+$/.test(name.trim())) {
      setSnackMsg(
        "Flex metadata can only contain letters, numbers, hyphens (-) and underscores (_)."
      );
      setOpenSnackbar(true);
      return;
    }
    const updatedList = [...flexMetaDataList, name];
     if (updatedList.length > 8) {
      setSnackMsg("Maximum of 8 flex metadata can be added.");
      setOpenSnackbar(true);
    }  else {
      if (findIndexOfNameAvailableOrNot === -1) {
        setNewLabelAdded(true);
        setNewLabelNotPresentInTheList(name);
        let obj = {};
        obj["title"] = name;
        dispatch(
          postFlexMetaDataLabels(sessionStorage.getItem("portfolioId"), obj)
        );
      } else {
        setFlexMetaDataList(updatedList);
        callTheSubmissionDetails(updatedList);
      }
      console.log("Saved Flex Metadata:", name);
    }
  };

  useEffect(() => {
    if (newLabelAdded && newLabelNotPresentInTheList !== "") {
      const index = flexMetaDataState.findIndex(
        (ele) => ele.title === newLabelNotPresentInTheList
      );
      if (index !== -1) {
        const updatedList = [...flexMetaDataList, newLabelNotPresentInTheList];
        callTheSubmissionDetails(updatedList);
        setNewLabelAdded(false);
        setNewLabelNotPresentInTheList("");
      }
    }
  }, [newLabelAdded, flexMetaDataState]);

  const canDelete = () => {
    return (
      submissionData &&
      Object.keys(submissionData).length > 0 &&
      (submissionData.reviewStatus === "PRODUCTION_APPROVAL_IN_REVIEW" ||
        submissionData.reviewStatus === "STAGING_APPROVAL_IN_REVIEW" ||
        submissionData.reviewStatus === "APPROVED_FOR_BETA" ||
        submissionData.reviewStatus === "REJECTED_AT_STAGING" ||
        submissionData.reviewStatus === "STAGING_APPROVAL_APPROVED" ||
        submissionData.reviewStatus === "REJECTED_AT_PRODUCTION" ||
        submissionData.reviewStatus === "PRODUCTION_APPROVAL_APPROVED" ||
        submissionData.status === "IN_REVIEW")
    );
  };

  const handleDelete = async (label_id) => {
    if (sessionStorage.getItem("customPortal") === "global-admin") {
      const filteredChipList = globalFlexMetaDataChipList.filter(
        (label) => label.id !== label_id
      );
      const updatedMetadataIds = filteredChipList.map((item) => item.id);

      const updatedSubmissionAPIData = {
        ...submissionAPIdata,
        flexMetadata: updatedMetadataIds,
      };

      await APIManager.setGlobalAdminFlexSubmissionAPIData(
        appId,
        submissionId,
        updatedSubmissionAPIData
      );

      dispatch(setSubmissionAPIdata(updatedSubmissionAPIData));
      dispatch(setGlobalFlexMetaDataChipList(filteredChipList));
      dispatch(setSubmissionFlexMetadataIds(updatedMetadataIds));
    } else {
      // For OEM admin, labels are strings, not objects with id
      const updateList = [...flexMetaDataList].filter(
        (label) => label !== label_id
      );
      console.log("updated list on delete", updateList);
      callTheSubmissionDetails(updateList);
    }

  };
console.log("flexmeta data list", flexMetaDataList);
  useEffect(() => {
    if (
      submissionData &&
      Object.keys(submissionData).length > 0 &&
      submissionData.labels &&
      submissionData.labels.length > 0
    ) {
      setFlexMetaDataList([...submissionData.labels]);
    }
  }, [submissionData, flexMetaDataState]);

  const callTheSubmissionDetails = (updatedList) => {
    console.log("Submission Data:", submissionData);
    const formData = new FormData();
    formData.append("labels", JSON.stringify(updatedList));
    const portfolioId = sessionStorage.getItem("portfolioId");
    const contenId = sessionStorage.getItem("contentId");
    dispatch(
      patchPortfolioAppApproveRejectDetails(portfolioId, contenId, formData)
    );
  };

  const isAddFlexDisabled = () => {
    if (sessionStorage.getItem("customPortal") === "global-admin") {
      // Disable when not in review OR when already at 8 chips
      if (submissionData?.status !== "IN_REVIEW") return true;
      if ((globalFlexMetaDataChipList?.length || 0) >= 8) return true;
    }
    // Read-only OEM admin cannot add
    if (sessionStorage.getItem("customPortal") === "oem-admin") {
      if (sessionStorage.getItem("readonly_OemAdmin") === "true") return true;

      const allowedStatuses = [
        "PRODUCTION_APPROVAL_IN_REVIEW",
        "STAGING_APPROVAL_IN_REVIEW",
        "APPROVED_FOR_BETA",
      ];

      const reviewStatus = submissionData?.reviewStatus;
      if (!allowedStatuses.includes(reviewStatus)) return true;

      // Maximum 8 labels
      if ((flexMetaDataList?.length || 0) >= 8) return true;
    }

    return false;
  };

  const handleAddFlexMetaDataOpen = () => {
    setAddDialogOpen(true);
  };

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start">
        <Grid2
          size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            display: "flex !important",
          }}
        >
          <div
            style={{
              width: "100%",
              marginLeft: "10%",
              marginTop: "10px",
              borderBottom: "1px solid rgba(18, 20, 21, 0.2)",
              marginBottom: "20px !important",
            }}
          >
            <div className="text-button-row">
              <Typography
                sx={{
                  "font-weight": "bold !important",
                  "font-size": "20px !important",
                  // "letter-spacing": "0.4px !important",
                  color: "rgba(18, 20, 21, 1) !important",
                }}
                className="uploadSignedApkText"
              >
                Flex Metadata
              </Typography>

              <Button
                disabled={isAddFlexDisabled()}
                sx={{
                  fontWeight: "400px !important",
                  fontSize: "12px !important",
                  letterSpacing: "0.4px !important",
                  lineHeight: "19.6px",
                  color: "rgba(4, 118, 226, 1) !important",
                  border: "1px solid rgba(4, 118, 226, 1) !important",
                  textTransform: "none",
                  height: "32px !important",
                  gap: "8px",
                }}
                onClick={handleAddFlexMetaDataOpen}
              >
                Add Flex Metadata
              </Button>
            </div>
            <div>
              {submissionData &&
                Object.keys(submissionData).length > 0 &&
                (submissionData.reviewStatus ===
                  "PRODUCTION_APPROVAL_IN_REVIEW" ||
                  submissionData.reviewStatus ===
                    "STAGING_APPROVAL_IN_REVIEW" ||
                  submissionData.status === "IN_REVIEW" ||
                  submissionData.reviewStatus === "APPROVED_FOR_BETA") && (
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#717273",
                    }}
                  >
                    Max of 8 flex metadata can be added.
                  </Typography>
                )}
            </div>
            <div style={{ marginTop: "10px", marginBottom: "20px" }}>
              <Grid2 container spacing={2} direction="row">
                {flexMetaDataList && flexMetaDataList.length > 0 &&
                  flexMetaDataList.map((label) => (
                    <Grid2 size={{ xs: 3 }} key={label}>
                      {submissionData.reviewStatus ===
                        "PRODUCTION_APPROVAL_IN_REVIEW" ||
                      submissionData.reviewStatus ===
                        "STAGING_APPROVAL_IN_REVIEW" ||
                      submissionData.reviewStatus === "APPROVED_FOR_BETA" ||
                      sessionStorage.getItem("readonly_OemAdmin") === "true" ? (
                        <Tooltip title={label} arrow>
                          <Chip
                            label={label}
                            onDelete={() => {
                              if (canDelete()) handleDelete(label);
                            }}
                            deleteIcon={
                              <CloseIcon
                                sx={{
                                  ...getDeleteIconStyles(),
                                  pointerEvents: canDelete() ? "auto" : "none",
                                }}
                              />
                            }
                            sx={getChipWithDeleteStyles()}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title={label} arrow>
                          <Chip
                            label={label}
                            sx={getChipWithoutDeleteStyles()}
                          />
                        </Tooltip>
                      )}
                    </Grid2>
                  ))}
                {(!flexMetaDataList || flexMetaDataList.length === 0) &&
                  globalFlexMetaDataChipList &&
                  globalFlexMetaDataChipList.length > 0 &&
                  globalFlexMetaDataChipList.map((label) => (
                    <Grid2 size={{ xs: 3 }} key={label}>
                      {submissionData.status === "IN_REVIEW" &&
                      sessionStorage.getItem("customPortal") ===
                        "global-admin" ? (
                        <Tooltip title={label.description} arrow>
                          <Chip
                            label={label.name}
                            onDelete={() => {
                              if (canDelete()) handleDelete(label.id);
                            }}
                            deleteIcon={
                              <CloseIcon
                                sx={{
                                  ...getDeleteIconStyles(),
                                  pointerEvents: canDelete() ? "auto" : "none",
                                }}
                              />
                            }
                            sx={getChipWithDeleteStyles()}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title={label.description} arrow>
                          <Chip
                            label={label.name}
                            sx={getChipWithoutDeleteStyles()}
                          />
                        </Tooltip>
                      )}
                    </Grid2>
                  ))}
                {(!flexMetaDataList || flexMetaDataList.length === 0) &&
                  (!globalFlexMetaDataChipList || globalFlexMetaDataChipList.length === 0) && (
                  <NoDataPlaceholder />
                )}
              </Grid2>
            </div>
          </div>
          <AddFlexMetaDataDialog
            appId={appId}
            submissionId={submissionId}
            open={addDialogOpen}
            flexMetaDataState={flexMetaDataState}
            flexNameOptions={flexNameOptions}
            onClose={() => setAddDialogOpen(false)}
            onSave={handleSave}
            onDuplicate={() => {
              setSnackMsg("This chip already exists.");
              setOpenSnackbar(true);
            }}
            fetchGlobalFlexChipsList={fetchGlobalFlexChipsList}
          />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSnackbar(false)}
            message={snackMsg}
            action={
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setOpenSnackbar(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />
        </Grid2>
      </Grid2>
    </Container>
  );
}

ApplicationDetailsFlexMetaData.propTypes = {
  submissionData: PropTypes.shape({
    reviewStatus: PropTypes.string,
    status: PropTypes.string,
    labels: PropTypes.array,
  }),
};

export default ApplicationDetailsFlexMetaData;
